const AboutPage = () => {
    return (
      <div className="mx-5 md:mx-40 mt-10 mb-20">
        <h2 className="text-3xl font-bold mb-4">About Campus Closet</h2>
        <p className="mb-6">
          Campus Closet is a convenient online marketplace for campus students to buy and sell second-hand and new items. Say goodbye to inconsistent methods like WhatsApp groups. Our platform streamlines the process, fostering connections between buyers and sellers within the campus community.
        </p>
        <p className="mb-6">
          Our mission is to create a centralized hub where students can confidently list their pre-owned items, ranging from households to electronics, gadgets, foodstuffs, and more. By doing so, we aim to save valuable time that would otherwise be spent on inefficient and fragmented marketing efforts. With Campus Closet, buyers can easily search and find the items they need, while sellers can reach a wider audience and make profitable transactions.
        </p>
        <p className="mb-6">
          Our user-friendly interface ensures a seamless experience, providing features such as item categorization, detailed descriptions, and clear images. We prioritize the safety and security of our users, implementing robust verification processes and promoting responsible and transparent transactions within the campus community.
        </p>
        <p className="mb-6">
          Join Campus Closet today and experience a hassle-free way of buying and selling second-hand items within your campus. Together, let's foster a thriving marketplace that connects students and promotes sustainability by giving pre-owned items a new life.
        </p>
        <p >
          <a href="/termsofuse" className="font-medium mb-6 hover:underline">Terms and conditions</a>
        </p>
      </div>
    );
  };
  
  export default AboutPage;
  
  